import { Measurements } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';

class BinIssueStateLevelFormWeight extends BinIssueStateMixin(LitEntity) {
  constructor() {
    super();
    this.collectedFields = ['correctedLevelWeight'];
    this.measurement = Measurements.get('weight');
  }

  static get styles() {
    return [...super.styles, css`
      .bin-level-select bin-profile {
        height: 25vh;
        max-height: 250px;
        flex-shrink: 4;
        width: auto;
      }
      .flex.col.left {
        align-items: flex-end;
      }
      .flex.col.right {
        align-items: flex-start;
      }
      h2 {
        margin-bottom: 0;
      }
      h4 {
        margin-bottom: 2rem;
      }
    `];
  }

  render() {
    return html`
      <div class="flex col bin-level-select">
        <h2>Estimate the Total Weight of the Feed</h2>
        <h4>Based on Your Suggested Level</h4>
        <div class="flex row">
          <div class="flex col left">
            <bin-profile
              .href="${this.href}"
              .level="${{ feedHeight: this.data.correctedLevelHeight }}"
              ignore-latest-level
            ></bin-profile>
          </div>

          <div class="flex col right">
            <bn-form-field
              type="number"
              title="Weight"
              value="${this.rawWeight}"
              @input="${(e) => this._onWeightInput(e)}"
            >
              <span slot="suffix" class="suffix">${this.measurement.unit}</span>
            </bn-form-field>
          </div>
        </div>
      </div>
      ${this.renderNext()}
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.data.correctedLevelWeight) {
      this.rawWeight = this.measurement.convert({ weight: this.data.correctedLevelWeight });
    }
    this.requestUpdate();
  }

  updated() {
    this.stateHasData = this.data.correctedLevelWeight >= 0;
  }

  _onWeightInput(e) {
    this.rawWeight = parseFloat(e.target.input.value);
    this.data.correctedLevelWeight = this.measurement.reverse({ weight: this.rawWeight });
    this.requestUpdate();
  }
}

window.customElements.define('bin-issue-state-level-form-weight', BinIssueStateLevelFormWeight);
